module.exports = __webpack_public_path__ + "static/media/animal.4c8a4619.svg";